import { navigate } from 'gatsby';
import PropTypes from 'prop-types';
import React from 'react';

import ContentfulImage from '../Common/ContentfulImage';
import { ArrowLink, PrimaryLink } from '../Common/Links';
import RichTextConverter from '../Common/RichText/RichTextConverter';
import * as styles from './FooterCallToAction.module.scss';

const FooterCallToAction = ({ section, className = '' }) => {
  const hasRefs = section?.relatedContent && section?.relatedContent?.length > 0;
  if (!section.image && !section.attachment) {
    return (
      <div
        className={[hasRefs ? styles.refGrid : styles.center, className].join(' ')}
        data-analytics-section={'footer-call-to-action'}
      >
        <div className={styles.cta}>
          <h2>{section.title}</h2>
          {section.description && <p>{section?.description?.description}</p>}
          <div className={styles.buttons}>
            {section.ctaLabel && <PrimaryLink label={section.ctaLabel} url={section.url || section.ctaUrl} isButton />}
            {section.secondaryLabel && (
              <ArrowLink
                className={styles.secondaryCta}
                label={section.secondaryLabel}
                url={section.secondaryUrl}
                hoverAnimation
              />
            )}
          </div>
        </div>
        {hasRefs && (
          <div className={styles.refContainer}>
            {section.relatedContent.map((item, i) => {
              const onClick = (e) => {
                if (e.target.nodeName === 'A') return;
                e?.preventDefault();
                if (item.linkUrl) {
                  navigate(item.linkUrl);
                }
                return;
              };
              return (
                <div
                  key={i}
                  className={[styles.refCard, item.linkUrl ? styles.pointer : ''].join(' ')}
                  onClick={onClick}
                >
                  {item.image && (
                    <ContentfulImage
                      aria-label={item.title}
                      lazy={true}
                      className={styles.cardImage}
                      imageFragment={item.image}
                    />
                  )}
                  <h4>{item.title}</h4>
                  <div className={styles.cardCopy}>
                    <RichTextConverter copy={item.body} />
                    <ArrowLink label={item.linkLabel} url={item.linkUrl} className={styles.arrowLink} />
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    );
  }
};

FooterCallToAction.propTypes = {
  section: PropTypes.object.isRequired,
};

export default FooterCallToAction;
